
import React, { useRef, useState } from 'react';
import { Pagina } from '../../componentes/pagina';
import { usePdf } from '@mikecousins/react-pdf';
// Create new plugin instance


export default function Programadeintegridade() {

  
    const [page, setPage] = useState(1);
    const canvasRef = useRef(null);

      const { pdfDocument} = usePdf({
        file: './pdf/Programa integridade AVAL 11.2023.pdf',
        page,
        canvasRef,
      });
  return (
    <>
    <Pagina titulo={"Programa de Integridade"}>
    <div className="pdf">

{!pdfDocument && <span>Loading...</span>}
<canvas ref={canvasRef} />
{Boolean(pdfDocument && pdfDocument.numPages) && (
  <nav>

        <button               class="ui button"
disabled={page === 1} onClick={() => setPage(page - 1)}>
          Anterior
        </button>

        <button
        class="ui button"
          disabled={page === pdfDocument.numPages}
          onClick={() => setPage(page + 1)}
        >
          Proximo
        </button>
 
  </nav>
)}
</div>


     </Pagina>
    </>
  )
}